var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgKeyboardArrowDown = function SvgKeyboardArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 15.17a.822.822 0 0 1-.313-.059.875.875 0 0 1-.284-.195l-4.95-4.95c-.153-.155-.225-.357-.217-.607a.873.873 0 0 1 .242-.609c.187-.188.39-.27.61-.245.22.025.414.114.584.267L12 13.101l4.328-4.329a.923.923 0 0 1 .611-.255.682.682 0 0 1 .608.258.646.646 0 0 1 .242.597c-.025.242-.114.449-.267.619l-4.925 4.925a.878.878 0 0 1-.284.195.826.826 0 0 1-.314.06"
  })));
};
export default SvgKeyboardArrowDown;